<template>
  <div class="user-center">
    <div class="user-center-container">
      <el-tabs class="user-tabs" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="账户信息" name="accountMsg">
          <user-message @getUserInfo="requestUserInfo" :userInfo="userInfo"></user-message>
        </el-tab-pane>
        <el-tab-pane label="订单管理" name="orderManage">
          <account-manage v-loading="isLoading" :data="orderList"></account-manage>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import UserMessage from '@/components/user-center/UserMessage';
import AccountManage from '@/components/user-center/AccountManage';
import api from '@/rest/questionQuery';
import getWechatCodeHelper from '@/helpers/getWechatCodeHelper';
import authService from '@/services/authService';

export default {
  data() {
    return {
      activeName: 'accountMsg',
      userInfo: undefined,
      isLoading: false,
      orderList: []
    };
  },
  methods: {
    handleClick(tab) {
      if (tab.name === 'orderManage') {
        this.requestOrderList();
      }
    },
    requestUserInfo() {
      api.getUserInfo().then(res => {
        this.userInfo = res;
      });
    },
    requestOrderList() {
      this.orderList = [];
      this.isLoading = true;
      api.getOrderList().then(res => {
        this.orderList = res.PageItems;
        this.isLoading = false;
      });
    }
  },
  mounted() {
    if (authService.getFromRouter() === '/recharge-result') {
      this.activeName = 'orderManage';
      this.requestOrderList();
    }
    if (getWechatCodeHelper.getUrlCode('code')) {
      const code = getWechatCodeHelper.getUrlCode('code');
      api.bindWechat(code).then(() => {
        this.requestUserInfo();
      });
    } else {
      this.requestUserInfo();
    }
  },
  components: {
    UserMessage,
    AccountManage
  }
};
</script>
<style lang="scss" scoped>
.user-center {
  padding: 24px 0;
  background-color: #f7f7fa;
  .user-center-container {
    width: 1200px;
    height: calc(100vh - 116px);
    margin: 0 auto;
    background-color: #ffffff;
    /deep/ {
      .el-tabs {
        .el-tabs__header {
          margin: 0;
          .el-tabs__nav-wrap {
            .el-tabs__nav-scroll {
              .el-tabs__nav {
                padding-left: 32px;
                .el-tabs__active-bar {
                  left: 32px;
                  background-color: #171f46;
                }
                .el-tabs__item {
                  height: 48px;
                  line-height: 48px;
                  font-size: 14px;
                  color: #747990;
                  &.is-active {
                    color: #171f46;
                  }
                }
              }
            }
            &::after {
              height: 1px;
              background-color: #f2f3f7;
            }
          }
        }
        .el-tabs__content {
          .el-tab-pane {
            padding: 32px 32px 0 32px;
          }
        }
      }
    }
  }
}
</style>
